// Keep below-fold photography out of the initial request queue. Native image
// sizing, high-DPR candidates, and the noscript fallback remain in the markup.
if (!customElements.get('nova-lazy-image')) {
  customElements.define('nova-lazy-image', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('template')) return;
      if (!('IntersectionObserver' in window)) {
        this.hydrate();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.hydrate();
      }, { rootMargin: '400px' });
      this.observer.observe(this.parentElement);
    }

    hydrate() {
      if (this.hydrated) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.hydrated = true;
      // Restore the original direct-child markup, including existing CSS rules.
      this.replaceWith(template.content.cloneNode(true));
      this.observer?.disconnect();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
